//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import contDialog from "./contDialog";
import { updateConfig } from "@/api/configurationlist";
import { workModel, protocal } from "./connConfig";
export default {
  props: ['Conn', 'deviceDid', 'deviceSn', 'com', 'noSname', 'vendorName', 'deviceSoftwareVer', 'nms'],
  components: {
    contDialog: contDialog
  },
  data: function data() {
    return {
      workModel: workModel,
      // 协议
      protocal: protocal,
      devName: ['Modbus RTU Master', 'Modbus RTU Slave', 'UART', 'Modbus ASCII Master', 'Modbus ASCII Slave'] //设备名称

    };
  },
  computed: {},
  methods: {
    // 修改连接配置
    connEdit: function connEdit(row, index) {
      this.$refs.connDialog.show(row, index);
    },
    // 添加连接配置
    addConn: function addConn() {
      this.$refs.connDialog.show('', this.Conn.length);
    },
    connDelet: function connDelet(row, index) {
      var _this = this;

      this.$confirm(this.$t('lang.Button.isDelete'), this.$t('lang.Button.tips'), {
        confirmButtonText: this.$t('lang.Button.submit'),
        cancelButtonClass: this.$t('lang.Button.cancel'),
        type: 'warning',
        center: true
      }).then(function () {
        updateConfig(_this.deviceSn, _this.deviceDid, [{
          section: "conn",
          config: "smartlink",
          action: 2,
          index: [index],
          // server: "smartlink",
          // options: {
          //   ...row.options
          // },
          lists: row.lists
        }]).then(function (res) {
          if (res.data.data.mess === 0) {
            _this.$message.success(_this.$t('lang.Button.successDelete'));

            _this.$emit('updateData');

            _this.dialogVisible = false;
          } else {
            _this.$message.error(_this.$t('lang.Button.failDelete'));
          }
        });
      });
    },
    updateData: function updateData() {
      this.$emit('updateData');
    }
  },
  watch: {
    deviceSn: {
      handler: function handler(val) {
        console.log(this.deviceSn);
      }
    } // deviceSoftwareVer:{
    //   immediate: true,
    //   handler() {
    //      console.log('version');
    //     console.log(this.deviceSoftwareVer);
    //     console.log(this.deviceSoftwareVer.indexOf('v2.2'));
    //     this.$set(this.workModel, '')
    //   }
    // }

  }
};